import { Injectable } from '@angular/core';
import { AppErrorDetails } from '@app/shared/components/error/error.model';

@Injectable({
  providedIn: 'root'
})
export class AppErrorStateService {
  private error: AppErrorDetails | null = null;

  setError(error: AppErrorDetails): void {
    this.error = error;
  }

  getError(): AppErrorDetails | null {
    return this.error;
  }

  clearError(): void {
    this.error = null;
  }
}
